// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep.matacc .mat-expansion-panel-header .mat-content {
  height: 24px !important;
}
::ng-deep.matacc .mat-expansion-panel-body {
  background-color: #f7f7f7 !important;
}

.caseclaim-timeline:before {
  content: "";
  position: relative;
  height: 10px;
  width: 10px;
  background-color: yellow;
  border-color: yellow;
  border-style: solid;
  border-width: 3px;
  margin-left: -9px;
  top: 17px;
  border-radius: 50%;
  display: inline-flex;
}

.caseclaim-timeline {
  border-color: #17a0b4;
  border-style: solid;
  border-width: 0 0 0 2px;
  margin-left: 11%;
  height: 12vh;
  padding-top: 13px;
}

.caseclaim-timelineexp {
  border-color: #17a0b4;
  border-style: solid;
  border-width: 0 0 0 2px;
  margin-left: 11%;
  height: 18vh;
  padding-top: 13px;
}

.caseclaim-timelineexp:before {
  content: "";
  position: relative;
  height: 10px;
  width: 10px;
  background-color: yellow;
  border-color: yellow;
  border-style: solid;
  border-width: 3px;
  margin-left: -9px;
  top: 17px;
  border-radius: 50%;
  display: inline-flex;
}

.perfdate {
  padding-top: 15px;
  margin-left: -162px;
  width: 11.5em;
  text-align: right;
  font-size: 12px;
}

.casedetail {
  margin-left: 3%;
  text-align: left;
  padding: 5px;
  position: relative;
  bottom: 8px;
  background-color: rgba(120, 130, 140, 0.13);
  width: 80%;
  font-size: 12px;
}

.expcontent {
  min-height: 20vh;
  max-height: 45vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.cardexp {
  min-height: 68vh;
  max-height: 68vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.claimnotes {
  width: 86%;
  height: 20px;
}

.claimnotesexp {
  width: 86%;
  min-height: 20px;
  max-height: 60px;
  overflow-x: hidden;
  overflow-y: auto;
}

.expanddiv {
  height: 18px;
  width: 18px;
  border-radius: 50%;
  background-color: #17a0b4;
}

.expandmore {
  font-size: 18px;
  color: black;
}

.expandless {
  font-size: 18px;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/case360/caseclaim/caseclaim.component.scss"],"names":[],"mappings":"AAEQ;EACI,uBAAA;AADZ;AAII;EACI,oCAAA;AAFR;;AAMA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;AAHJ;;AAKA;EACI,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AAFJ;;AAIA;EACI,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AADJ;;AAGA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;AAAJ;;AAEA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;AACJ;;AACA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,2CAAA;EACA,UAAA;EACA,eAAA;AAEJ;;AAAA;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAGJ;;AADA;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAIJ;;AAFA;EACI,UAAA;EACA,YAAA;AAKJ;;AAHA;EACI,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAMJ;;AAJA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AAOA;;AALA;EACI,eAAA;EACA,YAAA;AAQJ;;AANA;EACI,eAAA;EACA,YAAA;AASJ","sourcesContent":["::ng-deep.matacc{\r\n    .mat-expansion-panel-header{\r\n        .mat-content{\r\n            height: 24px !important;\r\n        }\r\n    }\r\n    .mat-expansion-panel-body{\r\n        background-color: #f7f7f7 !important;\r\n    }\r\n}\r\n\r\n.caseclaim-timeline:before{\r\n    content: \"\";\r\n    position: relative;\r\n    height: 10px;\r\n    width: 10px;\r\n    background-color: yellow;\r\n    border-color: yellow;\r\n    border-style: solid;\r\n    border-width: 3px;\r\n    margin-left: -9px;\r\n    top: 17px;\r\n    border-radius: 50%;\r\n    display: inline-flex;\r\n}\r\n.caseclaim-timeline{\r\n    border-color: #17a0b4;\r\n    border-style: solid;\r\n    border-width: 0 0 0 2px;\r\n    margin-left: 11%;\r\n    height: 12vh;\r\n    padding-top: 13px;\r\n}\r\n.caseclaim-timelineexp{\r\n    border-color: #17a0b4;\r\n    border-style: solid;\r\n    border-width: 0 0 0 2px;\r\n    margin-left: 11%;\r\n    height: 18vh;\r\n    padding-top: 13px;\r\n}\r\n.caseclaim-timelineexp:before{\r\n    content: \"\";\r\n    position: relative;\r\n    height: 10px;\r\n    width: 10px;\r\n    background-color: yellow;\r\n    border-color: yellow;\r\n    border-style: solid;\r\n    border-width: 3px;\r\n    margin-left: -9px;\r\n    top: 17px;\r\n    border-radius: 50%;\r\n    display: inline-flex;\r\n}\r\n.perfdate{\r\n    padding-top: 15px;\r\n    margin-left: -162px;\r\n    width: 11.5em;\r\n    text-align: right;\r\n    font-size: 12px;\r\n}\r\n.casedetail{\r\n    margin-left: 3%;\r\n    text-align: left;\r\n    padding: 5px;\r\n    position: relative;\r\n    bottom: 8px;\r\n    background-color: rgba(120, 130, 140, 0.13);\r\n    width: 80%;\r\n    font-size: 12px;\r\n}\r\n.expcontent{\r\n    min-height: 20vh;\r\n    max-height: 45vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n}\r\n.cardexp{\r\n    min-height: 68vh;\r\n    max-height: 68vh;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n}\r\n.claimnotes{\r\n    width: 86%;\r\n    height: 20px;\r\n}\r\n.claimnotesexp{\r\n    width: 86%;\r\n    min-height: 20px;\r\n    max-height: 60px;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n}\r\n.expanddiv{\r\nheight: 18px;\r\nwidth: 18px;\r\nborder-radius: 50%;\r\nbackground-color: #17a0b4;\r\n}\r\n.expandmore{\r\n    font-size: 18px;\r\n    color: black;\r\n}\r\n.expandless{\r\n    font-size: 18px;\r\n    color: black;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
